'use strict';

var React = require('react');

const IndexContext = /*#__PURE__*/React.createContext(undefined);
const IndexSelectionChangeContext = /*#__PURE__*/React.createContext(undefined);
const IndexRowContext = /*#__PURE__*/React.createContext(undefined);

exports.IndexContext = IndexContext;
exports.IndexRowContext = IndexRowContext;
exports.IndexSelectionChangeContext = IndexSelectionChangeContext;
